import {i18n} from '@online-offer/i18n';

import {Section} from '../../components/Section/Section';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {getRatingCardParams} from '../../utils/getRatingCardParams';
import {CertificateBadge} from './CertificateBadge';

export const Certificate = () => {
  const {vehicleAudit} = useGetOnlineOfferData();
  const audit = vehicleAudit?.audit;
  const ratings = getRatingCardParams(vehicleAudit);
  if (!audit && !ratings) {
    return;
  }
  return (
    <Section id="CERTIFICATE" isWithBreakLine>
      <CertificateBadge
        title={i18n.t('certificate.badge.title')}
        digitalCertificateVehicleId={audit?.id}
        ratings={ratings}
      />
    </Section>
  );
};
